import { render } from "./MenuItem.vue?vue&type=template&id=6f52b53f&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=6f52b53f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f52b53f"]])

export default __exports__